<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="title" id="title" type="text" pInputText>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode"
              optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
              placeholder="Select Property">
            </p-dropdown>
            <label for="Select Property">Select Property</label>
            @for (validation of validationMessages.shortTermRentalId; track validation) {
              <span>
                @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="payToDetails" formControlName="payTo" optionLabel="name"
            optionValue="value" placeholder="Pay To"></p-dropdown>
            <label for="Pay To">Pay To</label>
            @for (validation of validationMessages.payTo; track validation) {
              <span>
                @if (form1.get('payTo').hasError(validation.type) && (form1.get('payTo').dirty || form1.get('payTo').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-autoComplete class="col-lg-12" [suggestions]=" users" [multiple]="false" [forceSelection]="false" [dropdown]="false" [style]="{'width':'100%'}"
              [inputStyle]="{'width':'100%'}" [minLength]="2" unique="true" field="lastName" placeholder="Select User" (completeMethod)="onKeyInput($event)"
            formControlName="payToUserId"> </p-autoComplete>
            @for (validation of validationMessages.payToUserId; track validation) {
              <span>
                @if (form1.get('payToUserId').hasError(validation.type) && (form1.get('payToUserId').dirty || form1.get('payToUserId').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="payWhenStatuses" formControlName="payWhen" optionLabel="name"
            optionValue="value" placeholder="Pay When"></p-dropdown>
            <label for="Pay When">Pay When</label>
            @for (validation of validationMessages.payWhen; track validation) {
              <span>
                @if (form1.get('payWhen').hasError(validation.type) && (form1.get('payWhen').dirty || form1.get('payWhen').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="payStatuses" formControlName="payStatus" optionLabel="name"
            optionValue="value" placeholder="Pay Status"></p-dropdown>
            <label for="Pay Status">Pay Status</label>
            @for (validation of validationMessages.payStatus; track validation) {
              <span>
                @if (form1.get('payStatus').hasError(validation.type) && (form1.get('payStatus').dirty || form1.get('payStatus').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="quantity" id="quantity" type="number" pInputText>
            <label for="quantity">Quantity</label>
            @for (validation of validationMessages.quantity; track validation) {
              <span>
                @if (form1.get('quantity').hasError(validation.type) && (form1.get('quantity').dirty || form1.get('quantity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputMask formControlName="costAmount" id="costAmount" mask="9.99"></p-inputMask>
            <label for="costAmount">Cost Amount</label>
            @for (validation of validationMessages.costAmount; track validation) {
              <span>
                @if (form1.get('costAmount').hasError(validation.type) && (form1.get('costAmount').dirty || form1.get('costAmount').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-inputMask formControlName="costPercent" id="costPercent" mask="9.99"></p-inputMask>
            <label for="costPercent">Cost Percent</label>
            @for (validation of validationMessages.costPercent; track validation) {
              <span>
                @if (form1.get('costPercent').hasError(validation.type) && (form1.get('costPercent').dirty || form1.get('costPercent').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
            <label for="opsNotes">Optional Notes</label>
            @for (validation of validationMessages.opsNotes; track validation) {
              <span>
                @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>



      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (costProfileId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete Cost Profile</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!costProfileId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add Cost Profile</button>
              }

              @if (costProfileId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Cost Profile</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>